<div class="container-fluid p-4">
	<h3>Fiscal Year Info List</h3>
	<div class="d-flex gap-3 my-3 justify-content-between">
		<mat-form-field subscriptSizing="dynamic" style="width: 450px">
			<mat-label>Search</mat-label>
			<input matInput type="text" placeholder="Search" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" />
			@if (searchText()) {
				<button matSuffix mat-icon-button aria-label="Clear" (click)="searchText.set('')">⨉</button>
			}
		</mat-form-field>
		@if (sharedService.isRoles([enums.BOSS, enums.FINANCE])) {
			<button class="btn btn-primary" (click)="addFiscalYearInfo()"><i class="fas fa-plus"></i> Fiscal Year Info</button>
		}
	</div>
	<div class="d-flex gap-2 align-items-center">
		<div>Quick Filter:</div>
		<mat-chip-listbox class="gap-2 mb-1" multiple>
			@for (f of fiscalYears(); track f) {
				<mat-chip-option [selected]="yearFilter().includes(f)" (click)="setFilterYear(f)">{{ f }}</mat-chip-option>
			}
		</mat-chip-listbox>
	</div>
	<div class="table-responsive shadow">
		<table mat-table [dataSource]="table.dataSource()" matSort (matSortChange)="table.sortState.set($event)">
			@for (c of table.config(); track c.columnDef) {
				<ng-container [matColumnDef]="c.columnDef">
					<th mat-header-cell *matHeaderCellDef mat-sort-header [class]="c.cssClass?.header">{{ c.header }}</th>
					<td mat-cell *matCellDef="let f" [class]="c.cssClass?.cell">
						@if (c.onClick) {
							<div (click)="c.onClick(f)" class="pointer">{{ table.formatValue(f, c) }}</div>
						} @else {
							{{ table.formatValue(f, c) }}
						}
					</td>
				</ng-container>
			}
			@if (sharedService.isRoles([enums.BOSS, enums.EXPENSE_ADMIN])) {
				<ng-container matColumnDef="Actions" [stickyEnd]="true">
					<th mat-header-cell *matHeaderCellDef>Actions</th>
					<td mat-cell *matCellDef="let f">
						@if (f.EndMonth >= absCurrentMonth) {
							<button class="btn" (click)="updateFiscalYearInfo(f)" title="Edit"><i class="fas fa-pencil-alt text-secondary"></i></button>
						}
					</td>
				</ng-container>
			}
			<tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns()" [class.inactive]="!row.Active"></tr>
			<!-- #region 'Group Header' -->
			<ng-container matColumnDef="groupHeader">
				<td mat-cell [attr.colspan]="displayedColumns()?.length" *matCellDef="let group">
					{{ group.year }}
				</td>
			</ng-container>
			<tr mat-row *matRowDef="let group; columns: ['groupHeader']; when: isHeader" class="position-sticky bg-light fw-bold" style="top: 56px; z-index: 3" [class.d-none]=""></tr>
			<!-- #endregion -->
		</table>
	</div>
</div>
